export const ProductionIssueTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of Production issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Log into</span> the <span className="font-semibold">Enphase Enlighten
                Portal </span>at <a
                    href="https://enlighten.enphaseenergy.com/"
                    target="_blank"
                    rel="noreferrer"
                >https://enlighten.enphaseenergy.com/</a>, <span className="font-semibold">select</span> the
                warranty holder's site from the <span className="font-semibold">systems
                list,</span> and <span className="font-semibold">navigate</span> to
                the <span className="font-semibold">Devices tab</span> for detailed information.
            </li>
            <li>
                <span className="font-semibold">Look for</span> Microinverters with
                a <span className="font-semibold">Production Issue</span>, which will be indicated by a flag.
            </li>
            <li>
                <span className="font-semibold">Click</span> the <span className="font-semibold">status link</span> of a
                specific microinverter to view its current issues.
            </li>
            <li>
                For additional support, <span className="font-semibold">contact </span>
                <span className="font-semibold">Enphase Customer Support</span> for detailed troubleshooting steps.
            </li>
            <li>
                If no microinverters with production issues appear in the list, consider checking the
                system's <span className="font-semibold">Production Threshold settings</span>. They might be
                set too conservatively.
            </li>
            <li>
                <span className="font-semibold">Assess</span> recent weather conditions in the area, as unusual
                weather can trigger production issues by causing actual system production to fall below estimated
                production, even when the system is working properly.
            </li>
            <li>
                If weather frequently triggers false production issues, you may need
                to <span className="font-semibold">adjust the Production Threshold</span> lower than the current
                estimate.
            </li>
        </ul>
    </div>
